import http from "../config/http-common";

import authHeader from "./auth-header";


class IngredientDataService {
  getAllPaginated(params) {
    const response = http.get("/api/ingredients", {
      headers: authHeader(),
      params: params,
    });
    // console.log("response ", response);
    return response;
  }

  getAll(params) {
    const response = http.get("/api/ingredients/all", {
      headers: authHeader(),
      params: params,
    });
    // console.log("response ", response);
    return response;
  }

  get(id) {
    return http.get(`/api/ingredients/${id}`, { headers: authHeader() });
  }

  create(data) {
    // console.log("data ", data);
    return http.post("/api/ingredients/add", data, { headers: authHeader() });
  }

  update(id, data) {
    // console.log("data ", data)
    return http.put(`/api/ingredients/${id}`, data, { headers: authHeader() });
  }

  delete(id) {
    return http.delete(`/api/ingredients/${id}`, { headers: authHeader() });
  }

  deleteAll() {
    return http.delete(`/api/ingredients`, { headers: authHeader() });
  }

  findByName(name) {
    // console.log("findByName API call: name", name)
    return http.get(`/api/ingredients?name=${name}`, {
      headers: authHeader(),
    });
  }
}
export default new IngredientDataService();
